import * as yup from 'yup'

export const schemaForgotPassword = yup.object().shape({
  email: yup.string().email().required(),
})

export default schemaForgotPassword
